module.exports = __webpack_public_path__ + "img/pic2.beef000f.png";